import { BIReport } from "@lemmonhq/types";
import { getAPIClient } from "../helpers";

export const biAPI = {
  getReports: async (): Promise<BIReport[]> => {
    const hc = getAPIClient();
    const req = await hc.api.v2.bi.$get();
    if (req.ok) {
      const json = await req.json();
      return json;
    } else {
      throw new Error("unable to get reports");
    }
  },
  createReportRun: async (parameters: {
    type: string;
    reportType: string;
    startDate: string;
    endDate: string;
    locale: string;
  }): Promise<{ id: string; fileName: string }> => {
    const hc = getAPIClient();
    const req = await hc.api.v2.bi.$post({
      json: {
        type: parameters.type,
        reportType: parameters.reportType,
        startDate: parameters.startDate,
        endDate: parameters.endDate,
        locale: parameters.locale,
      },
    });
    if (req.ok) {
      const json = await req.json();
      return json;
    } else {
      throw new Error("unable to get reports");
    }
  },
  getReportRun: async (id: string) => {
    const hc = getAPIClient();
    const req = await hc.api.v2.bi[":id"].$get({
      param: {
        id,
      },
    });
    if (req.ok) {
      const json = await req.json();
      return json;
    } else {
      throw new Error("unable to get reports");
    }
  },
};
